import { render, staticRenderFns } from "./AddAuthor.vue?vue&type=template&id=16aa1362&scoped=true&"
import script from "./AddAuthor.vue?vue&type=script&lang=js&"
export * from "./AddAuthor.vue?vue&type=script&lang=js&"
import style0 from "./AddAuthor.vue?vue&type=style&index=0&id=16aa1362&lang=scss&scoped=true&"
import style1 from "./AddAuthor.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16aa1362",
  null
  
)

export default component.exports